import { render, staticRenderFns } from "./popup-choose-shang-pin.vue?vue&type=template&id=8955b212&scoped=true"
import script from "./popup-choose-shang-pin.vue?vue&type=script&lang=js"
export * from "./popup-choose-shang-pin.vue?vue&type=script&lang=js"
import style0 from "./popup-choose-shang-pin.vue?vue&type=style&index=0&id=8955b212&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8955b212",
  null
  
)

export default component.exports